import { render, staticRenderFns } from "./pageElementText.vue?vue&type=template&id=0a90727e&scoped=true&"
import script from "./pageElementText.vue?vue&type=script&lang=js&"
export * from "./pageElementText.vue?vue&type=script&lang=js&"
import style0 from "./pageElementText.vue?vue&type=style&index=0&id=0a90727e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a90727e",
  null
  
)

export default component.exports